import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { Capacitor } from "@capacitor/core";
import { SqlModule } from "../sqlite/sql.module";
import { BackgroundTaskDatabaseService } from "./services/background-task-database.service";
import { BrowserBackgroundTaskDatabaseService } from "./services/browser-background-task-database.service";
import { MobileBackgroundTaskDatabaseService } from "./services/mobile-background-task-database.service";
import { StoreBtsService } from "./services/store-bts.service";

@NgModule({
	imports: [SqlModule, CommonModule],
	providers: [
		StoreBtsService,
		{
			provide: BackgroundTaskDatabaseService,
			useClass: ["android", "ios"].includes(Capacitor.getPlatform())
				? MobileBackgroundTaskDatabaseService
				: BrowserBackgroundTaskDatabaseService
		},
		MobileBackgroundTaskDatabaseService,
		BrowserBackgroundTaskDatabaseService
	]
})
export class BTSModule {}
